<template>
    <div class="recent-games">
        <div class="display-1 recent-games-header">
            {{isPowerPuzzle? "Recent Power Puzzles":"Recent Puzzles"}}
        </div>

        <v-data-table
        
        :mobile-breakpoint="0"
            :headers="headers"
            :items="history"
            :items-per-page="10"
            :loading="loading"
            no-data-text="No games found"
            loading-text="Loading..."
            must-sort
            update: sort-desc
            :custom-sort="customSort"
            sortBy="puzzleDate"
            class="table-container transparent"
            background-color="transparent"
        >
            <template slot="item" slot-scope="props">
                <tr class="history-row">
                    <td class="text-left body-2">{{ props.item.puzzleDate }}</td>
                    <td class="text-right body-2">{{ props.item.wordPoints }}</td>
                    <td class="text-right body-2">{{ props.item.letterRevealsLeft }}</td>
                    <td v-if="!isPowerPuzzle"
                        class="text-right body-2"
                        :class="(props.item.wagerSuccess && props.item.wager !== 0) ? 'wager-success' : (!props.item.wagerSuccess && props.item.   wager !== 0) ? 'wager-fail' : '' "
                    >{{ props.item.wager }}</td>
                    <td class="text-right body-2">{{ props.item.totalPoints }}</td>
                </tr>
            </template>
        </v-data-table>
    </div>
</template>

<script>
/* eslint-disable */
import axios from "axios";
import moment from "moment";

export default {
    name: "RecentGames",
    props: ["isPowerPuzzle", "userHash", "authenticated"],
    components: {},
    data: () => {
        return {
            name: "",
            achievements: "",
            history: [],
            loading: false,
        };
    },
    mounted() {
        this.getProfileData(this.userHash);
    },
    computed: {
        headers() {
            return this.isPowerPuzzle
                ? [
                      { text: "Date", value: "puzzleDate", align: "left" },
                      {
                          text: "Word Points",
                          value: "wordPoints",
                          align: "right",
                      },
                      {
                          text: "Letter Reveals Used",
                          value: "letterRevealsLeft",
                          align: "right",
                      },
                      {
                          text: "Total Points",
                          value: "totalPoints",
                          align: "right",
                      },
                  ]
                : [
                      { text: "Date", value: "puzzleDate", align: "left" },
                      {
                          text: "Word Points",
                          value: "wordPoints",
                          align: "right",
                      },
                      {
                          text: "Letter Reveals Left",
                          value: "letterRevealsLeft",
                          align: "right",
                      },
                      { text: "Wager", value: "wager", align: "right" },
                      {
                          text: "Total Points",
                          value: "totalPoints",
                          align: "right",
                      },
                  ];
        },
    },
    methods: {
        customSort(items, valueArray, descendingArray) {
            let value = valueArray[0];
            let isDescending = descendingArray[0];

            items.sort((a, b) => {
                if (value === "puzzleDate") {
                    if (isDescending) {
                        return (
                            moment(b.puzzleDate).valueOf() -
                            moment(a.puzzleDate).valueOf()
                        );
                    } else {
                        return (
                            moment(a.puzzleDate).valueOf() -
                            moment(b.puzzleDate).valueOf()
                        );
                    }
                } else {
                    if (isDescending) {
                        return b[value] - a[value];
                    } else {
                        return a[value] - b[value];
                    }
                }
            });

            return items;
        },
        getProfileData(userHash) {
            axios
                .get(
                    `https://i0tr7oa202.execute-api.us-east-1.amazonaws.com/dev/getuserhistory?userHash=${userHash}&isPowerPuzzle=${this.isPowerPuzzle}`
                )
                .then((response) => {
                    this.name = response.data.name;
                    this.history = response.data.history.map((historyRow) => {
                        historyRow.letterRevealsLeft =
                            historyRow.letterRevealPoints
                                ? Math.abs(historyRow.letterRevealPoints / 50)
                                : 0;
                        historyRow.wager = Math.abs(historyRow.wagerPoints);
                        historyRow.wagerSuccess = historyRow.wagerPoints > 0;
                        return historyRow;
                    });
                })
                .catch((error) => {
                    console.log(error);
                });
        },
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.history-row td.wager-success {
    color: green;
}
.history-row td.wager-fail {
    color: red;
}
.recent-games {
    text-align: center;
    left: 0;
    right: 0;
    padding: 20px 20px 30px 20px;
    width: 90%;
    margin: auto;
    border: 2px solid $pod-teal;
    background: rgba(255, 255, 255, 0.9);
    border-radius: 8px;
}
.recent-games-header {
    font-family: "Chewy" !important;
    text-align: center;
    margin-bottom: 20px;
}

.username-dialog {
    background: white;
}

.generic-stat > div {
    margin-top: 12px;
}

.edit-button {
    margin-bottom: 18px;
}

.not-found-list {
    margin: 15px 0px;
}
.li {
    line-height: 25px;
}
</style>

<style lang="scss">
@media only screen and (max-width: 600px) {
    table th span {
        display: block !important;
    }
}

.recent-games .v-input__control .v-input__slot {
    background: transparent !important;
}
</style>

